import { useState, useEffect, useRef, useCallback } from "react";

// ── Design tokens ─────────────────────────────────────────────────────────────
const TOKEN = {
  dark: {
    bg:          "#0d0f1a",
    surface:     "#161924",
    surfaceAlt:  "#1c2030",
    border:      "#252a3a",
    borderMid:   "#333a52",
    textPrimary: "#f0f2ff",
    textSec:     "#b0b6d0",
    textMuted:   "#666e90",
    textFaint:   "#3a4060",
    courseRow:   "#111420",
  },
  light: {
    bg:          "#eef0f6",
    surface:     "#ffffff",
    surfaceAlt:  "#f4f6fc",
    border:      "#dde0ea",
    borderMid:   "#c0c5d8",
    textPrimary: "#0d1020",
    textSec:     "#3a4060",
    textMuted:   "#6b7290",
    textFaint:   "#b8bdd0",
    courseRow:   "#f8f9fd",
  },
};

const STATUS = {
  new:   { label: "NEW",   dot: "#4d90fe", accent: "#4d90fe" },
  prep:  { label: "PREP",  dot: "#f59e0b", accent: "#f59e0b" },
  ready: { label: "READY", dot: "#4caf50", accent: "#4caf50" },
  hold:  { label: "HOLD",  dot: "#ef5350", accent: "#ef5350" },
};

// ── Seed data ─────────────────────────────────────────────────────────────────
const SEED_ORDERS = [
  {
    id: 1, name: "JOHN DOE", type: "TAKE-OUT", guests: 2, server: "HANNAH",
    table: 44, placedAt: "10:07", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 1, course: 1, name: "Nachos",   mods: [],                              status: "new" },
      { id: 2, course: 1, name: "Omelette", mods: ["Extra cheese", "Brown bread"], status: "new" },
    ],
  },
  {
    id: 2, name: "SARAH LANE", type: "DINE-IN", guests: 4, server: "MIKE",
    table: 12, placedAt: "10:07", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 3, course: 1, name: "Caesar Salad",  mods: ["No croutons"],   status: "new" },
      { id: 4, course: 2, name: "Grilled Salmon", mods: ["Well done"],    status: "new" },
      { id: 5, course: 2, name: "Fries",          mods: ["Extra crispy"], status: "new" },
    ],
  },
  {
    id: 3, name: "EMMA CLARK", type: "TAKE-OUT", guests: 1, server: "HANNAH",
    table: 55, placedAt: "10:15", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 101, course: 1, name: "Club Sandwich", mods: ["No mayo"],          status: "new" },
      { id: 102, course: 1, name: "Onion Rings",   mods: ["Extra crispy"],     status: "new" },
      { id: 103, course: 1, name: "Iced Tea",       mods: ["No sugar"],         status: "new" },
      { id: 104, course: 1, name: "Cheese Burger",  mods: ["Medium"],           status: "new" },
      { id: 105, course: 1, name: "Fish Tacos",     mods: ["Spicy"],            status: "new" },
      { id: 106, course: 1, name: "Loaded Fries",   mods: ["Extra cheese"],     status: "new" },
      { id: 107, course: 1, name: "Spring Rolls",   mods: [],                   status: "new" },
      { id: 108, course: 1, name: "Garlic Bread",   mods: ["No garlic butter"], status: "new" },
      { id: 109, course: 2, name: "Mushroom Soup",  mods: ["Extra cream"],      status: "new" },
      { id: 110, course: 2, name: "Chicken Wings",  mods: ["BBQ sauce"],        status: "new" },
      { id: 111, course: 2, name: "Beef Stir Fry",  mods: ["Less salt"],        status: "new" },
      { id: 112, course: 2, name: "Veggie Wrap",    mods: [],                   status: "new" },
      { id: 113, course: 2, name: "Corn Chowder",   mods: ["No crackers"],      status: "new" },
      { id: 114, course: 2, name: "BBQ Ribs",       mods: ["Extra sauce"],      status: "new" },
      { id: 115, course: 2, name: "Mac & Cheese",   mods: ["Extra crispy top"], status: "new" },
      { id: 116, course: 2, name: "Fruit Salad",    mods: [],                   status: "new" },
      { id: 117, course: 3, name: "Cheesecake",     mods: ["Strawberry"],       status: "new" },
      { id: 118, course: 3, name: "Ice Cream",      mods: ["Vanilla"],          status: "new" },
      { id: 119, course: 3, name: "Chocolate Cake", mods: ["No nuts"],          status: "new" },
      { id: 120, course: 3, name: "Apple Pie",      mods: ["Extra cinnamon"],   status: "new" },
      { id: 121, course: 3, name: "Lemon Tart",     mods: ["Meringue"],         status: "new" },
      { id: 122, course: 3, name: "Pecan Pie",      mods: ["Extra pecans"],     status: "new" },
      { id: 123, course: 3, name: "Chocolate Cake", mods: ["No nuts"],          status: "new" },
      { id: 124, course: 3, name: "Apple Pie",      mods: ["Extra cinnamon"],   status: "new" },
      { id: 125, course: 3, name: "Lemon Tart",     mods: ["Meringue"],         status: "new" },
      { id: 126, course: 3, name: "Pecan Pie",      mods: ["Extra pecans"],     status: "new" },
      

      
    ],
  },
  {
    id: 4, name: "JAMES FORD", type: "DINE-IN", guests: 6, server: "MIKE",
    table: 22, placedAt: "10:05", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 201, course: 1, name: "Ribeye Steak",    mods: ["Medium rare", "Pepper sauce"], status: "new" },
      { id: 202, course: 1, name: "Lamb Chops",      mods: ["Rosemary jus"],                status: "new" },
      { id: 203, course: 1, name: "Duck Confit",     mods: ["Orange glaze"],                status: "new" },
      { id: 204, course: 1, name: "Beef Tartare",    mods: ["No capers"],                   status: "new" },
      { id: 205, course: 1, name: "Seafood Platter", mods: ["Extra lemon"],                 status: "new" },
      { id: 206, course: 1, name: "Caesar Wrap",     mods: [],                              status: "new" },
      { id: 207, course: 2, name: "Truffle Risotto", mods: ["Extra parmesan"],              status: "new" },
      { id: 208, course: 2, name: "Lobster Bisque",  mods: ["Less cream"],                  status: "new" },
      { id: 209, course: 2, name: "Grilled Octopus", mods: ["Chimichurri"],                 status: "new" },
      { id: 210, course: 2, name: "Wagyu Burger",    mods: ["No pickles", "Medium"],        status: "new" },
      { id: 211, course: 2, name: "Foie Gras",       mods: ["Brioche toast"],               status: "new" },
      { id: 212, course: 2, name: "Cheese Board",    mods: ["No blue cheese"],              status: "new" },
      { id: 213, course: 3, name: "Chocolate Lava",  mods: ["Extra vanilla ice cream"],     status: "new" },
      { id: 214, course: 3, name: "Tiramisu",        mods: ["Extra espresso"],              status: "new" },
      { id: 215, course: 3, name: "Panna Cotta",     mods: ["Raspberry coulis"],            status: "new" },
      { id: 216, course: 3, name: "Sorbet",          mods: ["Mango & Raspberry"],           status: "new" },
      { id: 217, course: 3, name: "Espresso",        mods: ["Double shot"],                 status: "new" },
      { id: 218, course: 3, name: "Digestif",        mods: [],                              status: "new" },
    ],
  },
  {
    id: 5, name: "TOM BAKER", type: "DINE-IN", guests: 2, server: "LISA",
    table: 7, placedAt: "10:12", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 30, course: 1, name: "Soup",       mods: [],               status: "new" },
      { id: 31, course: 1, name: "Bruschetta", mods: ["Extra tomato"], status: "new" },
    ],
  },
  {
    id: 6, name: "SOPHIA RAY", type: "DINE-IN", guests: 8, server: "LISA",
    table: 30, placedAt: "10:28", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 301, course: 1, name: "Starter Mix",      mods: [],               status: "new" },
      { id: 302, course: 1, name: "Shrimp Cocktail",  mods: ["Extra sauce"],  status: "new" },
      { id: 303, course: 1, name: "Smoked Salmon",    mods: ["Capers"],       status: "new" },
      { id: 304, course: 1, name: "Crab Cakes",       mods: [],               status: "new" },
      { id: 305, course: 1, name: "Tuna Tartare",     mods: ["No avocado"],   status: "new" },
      { id: 306, course: 2, name: "Pasta Primavera",  mods: ["No onion"],     status: "new" },
      { id: 307, course: 2, name: "Grilled Sea Bass", mods: ["Lemon butter"], status: "new" },
      { id: 308, course: 2, name: "Beef Tenderloin",  mods: ["Rare"],         status: "new" },
      { id: 309, course: 2, name: "Rack of Lamb",     mods: ["Mint sauce"],   status: "new" },
      { id: 310, course: 2, name: "Roasted Chicken",  mods: ["Gravy"],        status: "new" },
      { id: 311, course: 3, name: "Cheese Soufflé",   mods: [],               status: "new" },
      { id: 312, course: 3, name: "Fruit Tart",       mods: ["Cream aside"],  status: "new" },
      { id: 313, course: 3, name: "Crème Brûlée",     mods: ["Extra sugar"],  status: "new" },
      { id: 314, course: 3, name: "Choc Mousse",      mods: [],               status: "new" },
      { id: 315, course: 3, name: "Profiteroles",     mods: ["Extra choc"],   status: "new" },
    ],
  },
  {
    id: 7, name: "MARK LEE", type: "TAKE-OUT", guests: 1, server: "HANNAH",
    table: 60, placedAt: "10:22", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [{ id: 40, course: 1, name: "Burger", mods: ["No onion"], status: "new" }],
  },
  {
    id: 8, name: "DAVID KIM", type: "DINE-IN", guests: 5, server: "MIKE",
    table: 25, placedAt: "10:25", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 41, course: 1, name: "Steak", mods: ["Medium"], status: "new" },
      { id: 42, course: 2, name: "Wine",  mods: [],         status: "new" },
    ],
  },
  {
    id: 9, name: "ALICE GREEN", type: "DINE-IN", guests: 3, server: "LISA",
    table: 18, placedAt: "10:30", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 401, course: 1, name: "Garlic Shrimp", mods: [],               status: "new" },
      { id: 402, course: 2, name: "Pasta Alfredo", mods: ["Extra cheese"], status: "new" },
    ],
  },
  {
    id: 10, name: "ROBERT KING", type: "TAKE-OUT", guests: 2, server: "HANNAH",
    table: 0, placedAt: "10:32", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 403, course: 1, name: "Chicken Wrap", mods: ["No mayo"],    status: "new" },
      { id: 404, course: 1, name: "Fries",         mods: [],             status: "new" },
      { id: 405, course: 2, name: "Milkshake",     mods: ["Chocolate"], status: "new" },
    ],
  },
  {
    id: 11, name: "NINA PATEL", type: "DINE-IN", guests: 5, server: "MIKE",
    table: 9, placedAt: "10:35", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 406, course: 1, name: "Paneer Tikka",  mods: ["Spicy"],  status: "new" },
      { id: 407, course: 2, name: "Butter Chicken", mods: [],         status: "new" },
      { id: 408, course: 2, name: "Naan",           mods: ["Butter"], status: "new" },
    ],
  },
  {
    id: 12, name: "OLIVIA BROWN", type: "DINE-IN", guests: 6, server: "LISA",
    table: 14, placedAt: "10:40", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 410, course: 1, name: "Bruschetta", mods: [], status: "new" },
      { id: 411, course: 2, name: "Lasagna",    mods: [], status: "new" },
      { id: 412, course: 3, name: "Gelato",     mods: [], status: "new" },
    ],
  },
  {
    id: 13, name: "ETHAN WARD", type: "DINE-IN", guests: 2, server: "MIKE",
    table: 3, placedAt: "10:42", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 413, course: 1, name: "Soup",  mods: ["Hot"],  status: "new" },
      { id: 414, course: 2, name: "Steak", mods: ["Rare"], status: "new" },
    ],
  },
  {
    id: 14, name: "CHLOE SCOTT", type: "TAKE-OUT", guests: 2, server: "HANNAH",
    table: 0, placedAt: "10:45", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 415, course: 1, name: "Pizza", mods: ["Extra cheese"], status: "new" },
      { id: 416, course: 2, name: "Cola",  mods: [],               status: "new" },
    ],
  },
  {
    id: 15, name: "DANIEL YOUNG", type: "DINE-IN", guests: 4, server: "LISA",
    table: 11, placedAt: "10:47", prepAt: null, readyAt: null,
    kitchenDismissed: false,
    items: [
      { id: 417, course: 1, name: "Nachos",  mods: [],         status: "new" },
      { id: 418, course: 2, name: "Burger",  mods: ["Medium"], status: "new" },
      { id: 419, course: 3, name: "Brownie", mods: [],         status: "new" },
    ],
  },
];

// ── Helpers ───────────────────────────────────────────────────────────────────
function orderStatus(order) {
  const ss = order.items.map((i) => i.status);
  if (ss.every((x) => x === "hold"))  return "hold";
  if (ss.every((x) => x === "ready")) return "ready";
  if (ss.some((x) => x === "prep" || x === "ready")) return "prep";
  return "new";
}
function isFullyReady(order) { return order.items.every((i) => i.status === "ready"); }
function hasAnyReady(order)  { return order.items.some((i)  => i.status === "ready"); }
function nowStr() {
  return new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false });
}
function nextStatus(s) { return { new: "prep", prep: "ready", ready: "prep" }[s] ?? "prep"; }
function progressColor(pct) {
  if (pct === 0)  return "#4d90fe";
  if (pct < 100)  return "#f59e0b";
  return "#4caf50";
}

// ── Guest icon (SVG) ──────────────────────────────────────────────────────────
function GuestIcon({ size = 13, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, display: "block" }}>
      <circle cx="6"  cy="4.5" r="2.2" fill={color} />
      <path d="M1.5 14c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="11.5" cy="5.2" r="1.7" fill={color} opacity="0.5" />
      <path d="M8.5 14c0-2 1.3-3.5 3-4" stroke={color} strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}

// ── Toast ─────────────────────────────────────────────────────────────────────
function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(onClose, 2600);
    return () => clearTimeout(id);
  }, [toast, onClose]);

  if (!toast) return null;
  const P = {
    success: { bg: "#0f2a10", border: "#4caf5070", text: "#6fcf74" },
    warning: { bg: "#2a1c05", border: "#f59e0b70", text: "#fbbf24" },
    info:    { bg: "#0e1e38", border: "#4d90fe70", text: "#7ab4ff" },
    error:   { bg: "#2a0c0c", border: "#ef535070", text: "#f87171" },
  };
  const c = P[toast.severity] || P.info;
  return (
    <div style={{
      position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)",
      background: c.bg, border: `1.5px solid ${c.border}`, color: c.text,
      padding: "9px 20px", borderRadius: 8, fontWeight: 700, fontSize: 12,
      letterSpacing: 0.4, zIndex: 9999, whiteSpace: "nowrap",
      boxShadow: "0 6px 28px rgba(0,0,0,.55)", fontFamily: "inherit",
      animation: "fadeIn .15s ease",
    }}>{toast.msg}</div>
  );
}

// ── TimePill ──────────────────────────────────────────────────────────────────
function TimePill({ time, t }) {
  return (
    <span style={{
      fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 4,
      background: t.surfaceAlt, border: `1px solid ${t.border}`,
      color: t.textSec, letterSpacing: 0.2,
    }}>{time}</span>
  );
}

// ── Progress Bar ──────────────────────────────────────────────────────────────
function ProgressBar({ ready, total, t }) {
  const pct = total === 0 ? 0 : Math.round((ready / total) * 100);
  const col = progressColor(pct);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
      <div style={{ flex: 1, height: 4, background: t.border, borderRadius: 2, overflow: "hidden" }}>
        <div style={{
          height: "100%", width: `${pct}%`, background: col, borderRadius: 2,
          transition: "width .4s ease, background .4s ease",
        }} />
      </div>
      <span style={{ fontSize: 10, fontWeight: 800, color: col, minWidth: 34, textAlign: "right" }}>
        {ready}/{total}
      </span>
      {pct === 100 && <span style={{ fontSize: 10, fontWeight: 900, color: "#4caf50" }}>✓</span>}
    </div>
  );
}

// ── Item Checkbox ─────────────────────────────────────────────────────────────
function ItemCheckbox({ status, isLight }) {
  const s = ({
    new:   { bg: "transparent",                   border: isLight ? "#c0c5d8" : "#3a4060" },
    prep:  { bg: isLight ? "#fef3c7" : "#2a1f0a",  border: "#f59e0b" },
    ready: { bg: "#4caf50",                        border: "#4caf50" },
    hold:  { bg: "#ef5350",                        border: "#ef5350" },
  })[status] || { bg: "transparent", border: "#3a4060" };

  return (
    <div style={{
      width: 19, height: 19, borderRadius: 4, border: `1.5px solid ${s.border}`,
      background: s.bg, flexShrink: 0, display: "flex", alignItems: "center",
      justifyContent: "center", transition: "all .2s", marginTop: 1,
    }}>
      {status === "ready" && <span style={{ color: "#fff", fontSize: 11, fontWeight: 900, lineHeight: 1 }}>✓</span>}
      {status === "prep"  && <div style={{ width: 8, height: 8, background: "#f59e0b", borderRadius: 2 }} />}
      {status === "hold"  && (
        <div style={{ display: "flex", gap: 2, alignItems: "center" }}>
          <div style={{ width: 3, height: 9, background: "#fff", borderRadius: 1 }} />
          <div style={{ width: 3, height: 9, background: "#fff", borderRadius: 1 }} />
        </div>
      )}
    </div>
  );
}

// ── Bulk Strip ────────────────────────────────────────────────────────────────
function BulkStrip({ orderId, onBulk, t, isLight }) {
  const Btn = ({ label, action, color }) => (
    <button
      onClick={() => onBulk(orderId, action)}
      style={{
        height: 23, padding: "0 10px", borderRadius: 5, cursor: "pointer",
        fontFamily: "inherit", fontWeight: 800, fontSize: 9, letterSpacing: 0.5,
        border: `1px solid ${color}55`,
        background: isLight ? color + "1a" : color + "22",
        color: color, transition: "all .12s",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = color; e.currentTarget.style.color = "#fff"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = isLight ? color + "1a" : color + "22"; e.currentTarget.style.color = color; }}
    >{label}</button>
  );
  return (
    <div style={{
      display: "flex", gap: 2, padding: "6px 12px", flexWrap: "wrap",
      background: t.courseRow, borderBottom: `1px solid ${t.border}`, flexShrink: 0,
    }}>
      <Btn label="⬛ prep"  action="prep"  color="#f59e0b" />
      <Btn label="✓ ready" action="ready" color="#4caf50" />
      <Btn label="↺ reset"     action="new"   color={t.textMuted} />
    </div>
  );
}

// ── Item Row ──────────────────────────────────────────────────────────────────
// CHANGED: removed course-based grouping display, removed "compact" prop usage
function ItemRow({ item, onClick, waiterView, t, isLight }) {
  const is = item.status;
  const bgMap = {
    prep:  isLight ? "#fffbeb" : "#1c180a",
    ready: isLight ? "#f0fdf4" : "#0a1c0c",
    hold:  isLight ? "#fff1f1" : "#1c0a0a",
  };
  const bg = bgMap[is] || "transparent";

  return (
    <div
      onClick={waiterView ? undefined : onClick}
      style={{
        display: "flex", alignItems: "flex-start",
        padding: "9px 12px",
        borderBottom: `1px solid ${t.border}`, background: bg,
        cursor: waiterView ? "default" : "pointer", transition: "background .15s", gap: 8,
      }}
      onMouseEnter={(e) => { if (!waiterView) e.currentTarget.style.background = t.surfaceAlt; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = bg; }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{
          fontSize: 12, fontWeight: 600, lineHeight: 1.35, display: "block",
          color: is === "ready" ? t.textMuted : t.textPrimary,
          textDecoration: is === "ready" ? "line-through" : "none",
          opacity: is === "ready" ? 0.6 : 1, transition: "all .2s",
          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
        }}>{item.name}</span>
        {item.mods.map((m, i) => (
          <span key={i} style={{
            display: "block", fontSize: 9, color: t.textMuted, fontStyle: "italic", lineHeight: 1.35,
          }}>{m}</span>
        ))}
      </div>
      {is === "hold" && (
        <span style={{
          fontSize: 7, fontWeight: 800, padding: "2px 5px", borderRadius: 3,
          background: "#ef5350", color: "#fff", flexShrink: 0, alignSelf: "center",
        }}>HOLD</span>
      )}
      <ItemCheckbox status={is} isLight={isLight} />
    </div>
  );
}

// ── Card Header ───────────────────────────────────────────────────────────────
function CardHeader({ order, accent, t, isLight }) {
  const readyCnt = order.items.filter((i) => i.status === "ready").length;

  const typeChipColors = {
    "TAKE-OUT": { bg: isLight ? "#dbeafe" : "#152850", text: isLight ? "#1d4ed8" : "#93c5fd" },
    "DINE-IN":  { bg: isLight ? "#dcfce7" : "#0f3020", text: isLight ? "#15803d" : "#86efac" },
  };
  const tc = typeChipColors[order.type] || typeChipColors["DINE-IN"];

  return (
    <div style={{
      background: t.surfaceAlt, padding: "11px 13px 10px",
      borderBottom: `2.5px solid ${accent}`, flexShrink: 0, transition: "border-color .3s",
    }}>
      {/* Row 1 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 7 }}>
        <span style={{ fontWeight: 800, fontSize: 12, color: t.textPrimary, letterSpacing: 0.3, lineHeight: 1 }}>
          {order.name}
        </span>
        <span style={{
          fontSize: 8, fontWeight: 800, padding: "3px 7px", borderRadius: 4,
          background: tc.bg, color: tc.text, letterSpacing: 0.3, flexShrink: 0,
        }}>{order.type}</span>
      </div>

      {/* Row 2 */}
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <GuestIcon size={13} color={t.textMuted} />
          <span style={{ fontSize: 11, fontWeight: 700, color: t.textSec, lineHeight: 1 }}>{order.guests}</span>
        </div>
        {order.server && (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: t.textMuted, letterSpacing: 0.2 }}>Server</span>
            <span style={{ fontSize: 10, fontWeight: 800, color: t.textSec, letterSpacing: 0.2 }}>{order.server}</span>
          </div>
        )}
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
          <div style={{
            width: 8, height: 8, borderRadius: "50%", background: accent,
            boxShadow: `0 0 6px ${accent}`, border: `2px solid ${t.surface}`, flexShrink: 0,
          }} />
          <span style={{ fontWeight: 900, fontSize: 16, color: t.textPrimary, lineHeight: 1 }}>
            {order.table || "–"}
          </span>
        </div>
      </div>

      {/* Row 3 */}
      <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap" }}>
        <TimePill time={order.placedAt} t={t} />
        {order.prepAt  && (<><span style={{ fontSize: 8, color: t.borderMid }}>▶</span><TimePill time={order.prepAt}  t={t} /></>)}
        {order.readyAt && (<><span style={{ fontSize: 8, color: t.borderMid }}>▶</span><TimePill time={order.readyAt} t={t} /></>)}
        <span style={{ marginLeft: "auto", fontSize: 9, fontWeight: 700, color: t.textMuted }}>
          Course 1
        </span>
      </div>

      {/* Progress bar */}
      <ProgressBar ready={readyCnt} total={order.items.length} t={t} />
    </div>
  );
}

// ── Status Bar ────────────────────────────────────────────────────────────────
function StatusBar({ status, t }) {
  return (
    <div style={{
      borderTop: `1px solid ${t.border}`, display: "flex",
      flexShrink: 0, borderRadius: "0 0 11px 11px", overflow: "hidden",
    }}>
      {["new", "prep", "ready", "hold"].map((s, i) => {
        const active = status === s;
        const cfg = STATUS[s];
        return (
          <div key={s} style={{
            flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
            justifyContent: "center", padding: "6px 2px 5px", gap: 2,
            background: active ? cfg.dot + "1a" : t.courseRow,
            borderLeft: i > 0 ? `1px solid ${t.border}` : "none",
            transition: "background .3s",
          }}>
            <div style={{
              width: 7, height: 7, borderRadius: "50%",
              background: active ? cfg.dot : t.border,
              boxShadow: active ? `0 0 6px ${cfg.dot}99` : "none",
              transition: "all .25s",
            }} />
            <span style={{
              fontSize: 7, fontWeight: 800, letterSpacing: 0.5,
              color: active ? cfg.dot : t.textFaint, userSelect: "none",
            }}>{cfg.label}</span>
          </div>
        );
      })}
    </div>
  );
}

// ── Order Card ────────────────────────────────────────────────────────────────
// CHANGED: removed CompactToggle, removed course headers — items listed flat
function OrderCard({ order, holdMode, onItemClick, onBulk, mode }) {
  const t       = TOKEN[mode];
  const isLight = mode === "light";
  const status  = orderStatus(order);
  const cfg     = STATUS[status];

  return (
    <div style={{
      width: 244, minWidth: 244, flexShrink: 0,
      display: "flex", flexDirection: "column",
      borderRadius: 12, overflow: "hidden",
      border: `1.5px solid ${cfg.accent}50`,
      boxShadow: isLight
        ? `0 2px 14px rgba(0,0,0,.10), 0 0 0 1px ${cfg.accent}20`
        : `0 4px 28px rgba(0,0,0,.5), 0 0 0 1px ${cfg.accent}25`,
      background: t.surface, transition: "border-color .3s",
    }}>
      <div style={{ height: 3, background: `linear-gradient(90deg,${cfg.accent},${cfg.accent}99)`, flexShrink: 0 }} />
      <CardHeader order={order} accent={cfg.accent} t={t} isLight={isLight} />
      {order.items.length > 1 && (
        <BulkStrip orderId={order.id} onBulk={onBulk} t={t} isLight={isLight} />
      )}
      {/* Flat item list — no course headers */}
      <div style={{ overflowY: "auto", flex: 1, maxHeight: 340, minHeight: 60 }}>
        {order.items.map((item) => (
          <ItemRow key={item.id} item={item}
            onClick={() => onItemClick(order.id, item.id)} t={t} isLight={isLight} />
        ))}
      </div>
      <StatusBar status={status} t={t} />
    </div>
  );
}

// ── Waiter Card ───────────────────────────────────────────────────────────────
// CHANGED: removed CompactToggle, removed course headers — items listed flat
function WaiterCard({ order, onComplete, mode }) {
  const t       = TOKEN[mode];
  const isLight = mode === "light";
  const fully   = isFullyReady(order);
  const accent  = fully ? "#4caf50" : t.borderMid;

  return (
    <div style={{
      width: 244, minWidth: 244, flexShrink: 0,
      display: "flex", flexDirection: "column",
      borderRadius: 12, overflow: "hidden",
      border: `1.5px solid ${accent}50`,
      boxShadow: isLight ? `0 2px 14px rgba(0,0,0,.10)` : `0 4px 28px rgba(0,0,0,.5)`,
      background: t.surface,
    }}>
      <div style={{ height: 3, flexShrink: 0,
        background: fully ? "linear-gradient(90deg,#4caf50,#81c784)" : t.border }} />
      <CardHeader order={order} accent={accent} t={t} isLight={isLight} />
      {/* Flat item list — no course headers */}
      <div style={{ overflowY: "auto", flex: 1, maxHeight: 340, minHeight: 60 }}>
        {order.items.map((item) => (
          <ItemRow key={item.id} item={item} waiterView t={t} isLight={isLight} />
        ))}
      </div>
      <button
        disabled={!fully}
        onClick={fully ? () => onComplete(order.id) : undefined}
        style={{
          borderRadius: "0 0 10px 10px", border: "none", fontFamily: "inherit",
          fontWeight: 800, fontSize: 12, letterSpacing: 1.5,
          cursor: fully ? "pointer" : "not-allowed",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
          padding: "12px 0", flexShrink: 0, transition: "background .15s",
          background: fully ? "#2e7d32" : (isLight ? "#f0f1f5" : "#111420"),
          color: fully ? "#fff" : t.textMuted,
        }}
        onMouseEnter={(e) => { if (fully) e.currentTarget.style.background = "#388e3c"; }}
        onMouseLeave={(e) => { if (fully) e.currentTarget.style.background = "#2e7d32"; }}
      >
        {fully ? "✓  COMPLETED" : "⏳  PARTIALLY READY"}
      </button>
    </div>
  );
}

// ── Completed Card (accordion, single-open) ───────────────────────────────────
// CHANGED: accepts openId/setOpenId for single-accordion behavior; no course headers
function CompletedCard({ order, mode, isOpen, onToggle }) {
  const t       = TOKEN[mode];
  const isLight = mode === "light";

  return (
    <div
      style={{
        width: "100%",
        display: "flex", flexDirection: "column",
        borderRadius: 12, overflow: "hidden",
        border: `1.5px solid ${t.borderMid}50`,
        background: t.surface,
        transition: "opacity .2s, box-shadow .2s",
        boxShadow: isOpen
          ? (isLight ? "0 4px 18px rgba(0,0,0,.12)" : "0 4px 24px rgba(0,0,0,.55)")
          : "none",
      }}
    >
      <div style={{ height: 3, background: t.border, flexShrink: 0 }} />

      {/* Accordion header */}
      <div onClick={onToggle} style={{
        background: t.surfaceAlt, padding: "10px 13px 9px",
        borderBottom: isOpen ? `1.5px solid ${t.border}` : "none",
        cursor: "pointer", transition: "background .15s",
      }}
        onMouseEnter={(e) => e.currentTarget.style.background = t.border}
        onMouseLeave={(e) => e.currentTarget.style.background = t.surfaceAlt}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <span style={{ fontWeight: 800, fontSize: 11, color: t.textSec }}>{order.name}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
            <span style={{ fontSize: 9, fontWeight: 800, color: "#4caf5099" }}>✓ {order.completedAt}</span>
            <span style={{
              color: t.textMuted, fontSize: 11, fontWeight: 800,
              transition: "transform .2s",
              display: "inline-block",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}>▼</span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <span style={{ fontSize: 9, color: t.textMuted }}>
            TBL <b style={{ color: t.textSec }}>{order.table || "–"}</b>
          </span>
          <span style={{ fontSize: 9, color: t.textMuted }}>{order.items.length} items</span>
          {order.server && (
            <span style={{ fontSize: 9, color: t.textMuted }}>
              Server <b style={{ color: t.textSec }}>{order.server}</b>
            </span>
          )}
        </div>
      </div>

      {/* Expanded items — flat list, no course headers */}
      {isOpen && (
        <div style={{ overflowY: "auto", maxHeight: 320 }}>
          {order.items.map((item) => (
            <div key={item.id} style={{
              display: "flex", alignItems: "center", padding: "7px 13px",
              borderBottom: `1px solid ${t.border}`, gap: 8,
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{
                  display: "block", fontSize: 11, fontWeight: 600,
                  color: t.textMuted, textDecoration: "line-through", opacity: 0.6,
                  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                }}>{item.name}</span>
                {item.mods && item.mods.map((m, i) => (
                  <span key={i} style={{ display: "block", fontSize: 9, color: t.textFaint, fontStyle: "italic" }}>{m}</span>
                ))}
              </div>
              <div style={{
                width: 16, height: 16, borderRadius: 3,
                border: `1.5px solid #4caf5044`,
                background: isLight ? "#f0fdf4" : "#0a1c0c",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              }}>
                <span style={{ color: "#4caf5077", fontSize: 10, fontWeight: 900 }}>✓</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Empty State ───────────────────────────────────────────────────────────────
function EmptyState({ emoji, label, t }) {
  return (
    <div style={{
      margin: "auto", textAlign: "center", padding: "55px 40px",
      border: `2px dashed ${t.border}`, borderRadius: 14,
    }}>
      <div style={{ fontSize: 38, marginBottom: 10 }}>{emoji}</div>
      <div style={{ fontSize: 13, color: t.textMuted, fontWeight: 700 }}>{label}</div>
    </div>
  );
}

// ── Filter Tabs ───────────────────────────────────────────────────────────────
const FILTER_TABS = [
  { key: "ALL",       col: "#e8500a" },
  { key: "NEW",       col: "#4d90fe" },
  { key: "PREP",      col: "#f59e0b" },
  { key: "READY",     col: "#4caf50" },
  { key: "HOLD",      col: "#ef5350" },
  { key: "COMPLETED", col: "#a78bfa" },
];

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN
// ═══════════════════════════════════════════════════════════════════════════════
export default function KitchenDisplay() {
  const [colorMode, setColorMode] = useState(() => {
    try { return localStorage.getItem("kds-theme") || "dark"; } catch { return "dark"; }
  });
  const [orders,          setOrders]          = useState(SEED_ORDERS);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [activeFilter,    setFilter]          = useState("ALL");
  const [holdMode,        setHoldMode]        = useState(false);
  const [toast,           setToast]           = useState(null);
  // ADDED: track which completed card is open (accordion — only one at a time)
  const [openCompletedId, setOpenCompletedId] = useState(null);
  const timers = useRef({});

  const isLight     = colorMode === "light";
  const isDark      = !isLight;
  const t           = TOKEN[colorMode];
  const isReadyView = activeFilter === "READY";
  const isDoneView  = activeFilter === "COMPLETED";

  const toggleTheme = useCallback(() => {
    setColorMode((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      try { localStorage.setItem("kds-theme", next); } catch {}
      return next;
    });
  }, []);

  useEffect(() => {
    orders.forEach((order) => {
      const os = orderStatus(order);
      if (os === "ready" && !order.kitchenDismissed && !timers.current[order.id]) {
        timers.current[order.id] = setTimeout(() => {
          setOrders((prev) =>
            prev.map((o) =>
              o.id === order.id ? { ...o, kitchenDismissed: true } : o
            )
          );
          delete timers.current[order.id];
          show("Order moved to READY tab", "success");
        }, 20000);
      } else if (os !== "ready" && timers.current[order.id]) {
        clearTimeout(timers.current[order.id]);
        delete timers.current[order.id];
      }
    });
  }, [orders]);

  const handleItemClick = useCallback((orderId, itemId) => {
    setOrders((prev) => prev.map((order) => {
      if (order.id !== orderId) return order;
      const items = order.items.map((item) => {
        if (item.id !== itemId) return item;
        if (holdMode) {
          const next = item.status === "hold" ? "new" : "hold";
          show(next === "hold" ? "Item ON HOLD" : "Hold removed", next === "hold" ? "warning" : "info");
          return { ...item, status: next };
        }
        if (item.status === "hold") { show("Enable HOLD mode to change hold items", "warning"); return item; }
        const next = nextStatus(item.status);
        show(`Marked ${STATUS[next].label}`, "info");
        return { ...item, status: next };
      });
      const allInPrep = items.every((i) => i.status !== "new");
      const allReady  = items.every((i) => i.status === "ready");
      return {
        ...order,
        items,
        kitchenDismissed: allReady ? order.kitchenDismissed : false,
        prepAt:  allInPrep && !order.prepAt  ? nowStr() : order.prepAt,
        readyAt: allReady  && !order.readyAt ? nowStr() : order.readyAt,
      };
    }));
  }, [holdMode]);

  const handleBulk = useCallback((orderId, newStatus) => {
    setOrders((prev) => prev.map((order) => {
      if (order.id !== orderId) return order;
      const items = order.items.map((item) =>
        item.status === "hold" ? item : { ...item, status: newStatus }
      );
      const allInPrep = items.every((i) => i.status !== "new");
      const allReady  = items.every((i) => i.status === "ready");
      return {
        ...order,
        items,
        kitchenDismissed: allReady ? order.kitchenDismissed : false,
        prepAt:  allInPrep && !order.prepAt  ? nowStr() : order.prepAt,
        readyAt: allReady  && !order.readyAt ? nowStr() : order.readyAt,
      };
    }));
    show(`All items → ${STATUS[newStatus]?.label || newStatus}`, "info");
  }, []);

  const handleComplete = useCallback((orderId) => {
    const order = orders.find((o) => o.id === orderId);
    if (order) {
      const completed = { ...order, completedAt: nowStr() };
      setCompletedOrders((p) => [completed, ...p]);
      // Auto-open the newly completed card
      setOpenCompletedId(completed.id);
    }
    setOrders((p) => p.filter((o) => o.id !== orderId));
    show("Order completed & served ✓", "success");
  }, [orders]);

  // ADDED: accordion toggle handler — closes if same, opens otherwise
  const handleToggleCompleted = useCallback((id) => {
    setOpenCompletedId((prev) => prev === id ? null : id);
  }, []);

  const show = (msg, severity = "info") => setToast({ msg, severity });

  const counts = {
    ALL:       orders.length,
    NEW:       orders.filter((o) => orderStatus(o) === "new").length,
    PREP:      orders.filter((o) => orderStatus(o) === "prep").length,
    READY:     orders.filter((o) => hasAnyReady(o)).length,
    HOLD:      orders.filter((o) => orderStatus(o) === "hold").length,
    COMPLETED: completedOrders.length,
  };

  const kitchenFiltered = (() => {
    const base = orders.filter((o) => !o.kitchenDismissed);
    if (activeFilter === "ALL")  return base;
    if (activeFilter === "HOLD") return base.filter((o) => orderStatus(o) === "hold");
    return base.filter((o) => orderStatus(o) === activeFilter.toLowerCase());
  })();

  const waiterFiltered = orders.filter((o) => hasAnyReady(o));

  return (
    <div style={{
      background: t.bg, minHeight: "100vh",
      display: "flex", flexDirection: "column",
      fontFamily: "'JetBrains Mono', 'IBM Plex Mono', 'Courier New', monospace",
    }}>

      {/* ── Top bar ─────────────────────────────────────────────────────── */}
      <div style={{
        background: "#bf3b08", display: "flex", alignItems: "center",
        padding: "0 14px", height: 52, gap: 10, flexShrink: 0,
        boxShadow: "0 3px 22px rgba(180,50,0,.4)",
      }}>
        <span style={{ color: "#fff", fontWeight: 800, fontSize: 13, whiteSpace: "nowrap", letterSpacing: 0.3 }}>
          Point of Sale 1
        </span>
        <div style={{ width: 1, height: 28, background: "rgba(255,255,255,.22)", flexShrink: 0 }} />

        <div style={{ display: "flex", gap: 5, flex: 1, flexWrap: "wrap", alignItems: "center" }}>
          {FILTER_TABS.map(({ key, col }) => {
            const active = activeFilter === key;
            return (
              <button key={key} onClick={() => setFilter(key)} style={{
                height: 26, padding: "0 10px", borderRadius: 13,
                fontFamily: "inherit", fontWeight: 800, fontSize: 10,
                display: "flex", alignItems: "center", gap: 5,
                cursor: "pointer", transition: "all .15s", letterSpacing: 0.4,
                background: active ? "rgba(255,255,255,.96)" : "rgba(255,255,255,.13)",
                color: active ? col : "#fff",
                border: active ? "1.5px solid rgba(255,255,255,.5)" : "1.5px solid transparent",
              }}>
                {key}
                <span style={{
                  fontSize: 9, fontWeight: 900, padding: "1px 5px",
                  borderRadius: 7, lineHeight: 1.6,
                  background: active ? col : "rgba(255,255,255,.22)",
                  color: "#fff",
                }}>{counts[key]}</span>
              </button>
            );
          })}
        </div>

        <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
          <button onClick={() => {
            setHoldMode((v) => !v);
            show(holdMode ? "Hold mode OFF" : "Hold mode ON — tap item to hold", holdMode ? "info" : "warning");
          }} style={{
            height: 28, padding: "0 11px", borderRadius: 6,
            fontFamily: "inherit", fontWeight: 800, fontSize: 10,
            display: "flex", alignItems: "center", gap: 5,
            cursor: "pointer", transition: "all .15s", letterSpacing: 0.5,
            border: "1.5px solid #ef5350",
            background: holdMode ? "#ef5350" : "rgba(255,255,255,.93)",
            color: holdMode ? "#fff" : "#ef5350",
            boxShadow: holdMode ? "0 0 14px rgba(239,83,80,.45)" : "none",
          }}>
            ⏸ {holdMode ? "HOLD ON" : "HOLD"}
          </button>

          <button onClick={toggleTheme} title={`Switch to ${isDark ? "light" : "dark"} mode`} style={{
            width: 30, height: 30, borderRadius: 7, border: "none", cursor: "pointer",
            background: "rgba(255,255,255,.13)", color: "rgba(255,255,255,.88)",
            fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center",
            transition: "background .15s",
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,.26)"}
          onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,.13)"}
          >
            {isDark ? "☀️" : "🌙"}
          </button>
        </div>
      </div>

      {/* ── Cards area ──────────────────────────────────────────────────── */}
      {isDoneView ? (
        // Completed tab — vertical scroll, 6-column grid, accordion
        <div style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "14px 16px",
          display: "grid",
          gridAutoRows: "min-content",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: 8,
          alignItems: "start",
          alignContent: "start" 
        }}>
          {completedOrders.length === 0 ? (
            <EmptyState emoji="📋" label="No completed orders" t={t} />
          ) : (
            completedOrders.map((o) => (
              <CompletedCard
                key={o.id}
                order={o}
                mode={colorMode}
                isOpen={openCompletedId === o.id}
                onToggle={() => handleToggleCompleted(o.id)}
              />
            ))
          )}
        </div>
      ) : (
        // Kitchen / Waiter / other tabs — horizontal scroll (original behavior)
        <div style={{
          flex: 1, padding: 12, display: "flex", gap: 10,
          overflowX: "auto", overflowY: "hidden", alignItems: "flex-start",
        }}>
          {isReadyView ? (
            waiterFiltered.length === 0
              ? <EmptyState emoji="✅" label="No ready orders" t={t} />
              : waiterFiltered.map((o) => (
                  <WaiterCard key={o.id} order={o} onComplete={handleComplete} mode={colorMode} />
                ))
          ) : kitchenFiltered.length === 0 ? (
            <EmptyState emoji="🍽️" label="No orders here" t={t} />
          ) : kitchenFiltered.map((o) => (
              <OrderCard key={o.id} order={o} holdMode={holdMode} mode={colorMode}
                onItemClick={handleItemClick} onBulk={handleBulk} />
            ))}
        </div>
      )}

      <Toast toast={toast} onClose={() => setToast(null)} />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;600;700;800&display=swap');
        * { box-sizing: border-box; }
        button { outline: none; }
        ::-webkit-scrollbar { width: 3px; height: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: ${isLight ? "#c0c5d8" : "#2e3450"}; border-radius: 3px; }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateX(-50%) translateY(-6px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </div>
  );
}
